module.exports = __webpack_public_path__ + "img/伊藤.710e0214.jpg";